module.exports = __webpack_public_path__ + "img/yuyuezixun.fc8d5f3e.png";